import React, { PropsWithChildren } from 'react';

import { PublicCopilotLayout } from '@/components/PublicCopilotLayout';

import styles from '../CopilotPage.module.scss';

const RenderCopilotSetup: React.FC<PropsWithChildren<{}>> = ({ children }) => {
	return (
		<PublicCopilotLayout.SplitScreen
			top={
				<div className={styles['flex-to-bottom']}>
					<div className={styles['icons']}>
						<img src="/assets/asaph-1024-no-padding.svg" />
					</div>
					<h1>Connecting to Asaph</h1>
					<div className={styles['blurb']}>
						Asaph will check for an existing account prior to
						syncing with your Planning Center account.
					</div>
				</div>
			}
			bottom={<>{children}</>}
		/>
	);
};

export default RenderCopilotSetup;
